import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Skeleton, Tab, Tabs } from "@mui/material";
import * as styles from "./UserDetailsPage.module.scss";
import RoleActivity from "../../../Components/UserManagment/RoleActivity/RoleActivity";
import AuditHistory from "../../../Components/UserManagment/AuditHistory/AuditHistory";
import { getUserMgmtUserDetails } from "../../../services/RequestAccess/RequestAccess";
import CustomBreadcrumb from "../../../Components/CustomBreadcrumb/CustomBreadcrumb";

const UserDetailsPage: React.FC = () => {
  const scssClass = styles as any;
  const { workID } = useParams();
  const [tabValue, setTabValue] = useState<number>(0);
  const [isUserDetailsLoading, setIsUserDetailsLoading] =
    useState<boolean>(true);
  const [userDetails, setUserDetails] = useState<{
    username: string | null;
    region: string | null;
    department: string | null;
  }>({ username: null, region: null, department: null });

  const fetchUserDetails = async () => {
    setIsUserDetailsLoading(true);
    const resp = await getUserMgmtUserDetails(workID ?? "");
    setUserDetails({
      username: resp?.data?.user_name,
      region: resp?.data?.current_region,
      department: resp?.data?.current_department,
    });
  };
  useEffect(() => {
    if (workID) {
      fetchUserDetails().then(() => setIsUserDetailsLoading(false));
    }
  }, [workID]);
  return (
    <div className={scssClass?.page}>
      <CustomBreadcrumb
        items={[
          {
            label: "User Access",
            href: "/user-access",
            icon: <HomeOutlinedIcon sx={{ color: "#2469FF" }} />,
          },
          {
            label: `${workID}`,
            href: undefined,
          },
        ]}
      />

      <Card className={scssClass?.workidinfo}>
        <div className={scssClass?.infoSection}>
          {isUserDetailsLoading ? (
            <Skeleton
              variant="rounded"
              width={"200px"}
              height={"30px"}
              className={scssClass?.titleSection}
            />
          ) : (
            <div className={scssClass?.titleSection}>
              {userDetails.username ?? "N/A"}
            </div>
          )}
          {isUserDetailsLoading ? (
            <Skeleton variant="rounded" width={"400px"} height={"20px"} />
          ) : (
            <div className={scssClass?.infoDetails}>
              <div className={scssClass?.infoText}>
                Workday ID: {workID ?? ""}
              </div>
              <div className={scssClass?.seperator}></div>
              <div className={scssClass?.infoText}>
                Region: {userDetails?.region ?? "N/A"}
              </div>
              <div className={scssClass?.seperator}></div>
              <div className={scssClass?.infoText}>
                Department: {userDetails?.department ?? "N/A"}
              </div>
            </div>
          )}
        </div>

        <div>
          <Tabs
            value={tabValue}
            onChange={(event: React.SyntheticEvent, newValue: number) => {
              setTabValue(newValue);
            }}
            variant="standard"
            aria-label="Role Management"
            sx={{
              "& .MuiButtonBase-root": {
                color: "black !important",
                backgroundColor: "white",
              },
              "& .MuiTabs-indicator": {
                color: "black !important",
                backgroundColor: "black !important",
              },
              "& .MuiTabs-root": {
                marginBottom: "0px !important",
              },
            }}
          >
            <Tab
              label="Role Activity"
              sx={{
                padding: "1rem 2rem",
                textTransform: "none",
                fontWeight: tabValue === 0 ? "bold" : "",
              }}
            />
            <Tab
              label="Audit History"
              sx={{
                padding: "1rem 2rem",
                textTransform: "none",
                fontWeight: tabValue === 1 ? "bold" : "",
              }}
            />
          </Tabs>
        </div>
      </Card>
      {tabValue === 0 ? (
        <RoleActivity workdayID={workID ?? ""} />
      ) : tabValue === 1 ? (
        <AuditHistory workdayID={workID ?? ""} />
      ) : (
        <></>
      )}
    </div>
  );
};

export default UserDetailsPage;
